import React, { useState, useEffect } from 'react';
import { Menu, Button } from 'antd';
import type { MenuProps } from 'antd';
import type { SelectInfo } from 'rc-menu/lib/interface';
import { MenuFoldOutlined, MenuUnfoldOutlined,SafetyCertificateOutlined} from '@ant-design/icons';
import { UserInfo } from '@/models/perms_type';
import styles from './index.module.less';

type MenuItem = Required<MenuProps>['items'][number];


interface PermsNavMenuProps {
    userInfo: UserInfo;
    collapsed: boolean;
    permsNavMenu: MenuItem[];
    onCollapse: (collapsed: boolean) => void;
    handleJumpTo: (path: string) => void; 
    pathname:string
}

const PermsNavMenu: React.FC<PermsNavMenuProps> = ({ 
    userInfo,
    collapsed,
    permsNavMenu,
    onCollapse,
    handleJumpTo,
    pathname,
}) => {
    const [openKeys, setOpenKeys] = useState<string[]>([]);

    useEffect(() => {
        if (collapsed) {
            setOpenKeys([]);
            return;
        }
        const firstKey = permsNavMenu[0]?.key;
        setOpenKeys(firstKey != null ? [String(firstKey)] : []);
    }, [collapsed, permsNavMenu]);

    const handleCollapse = () => {
        onCollapse(!collapsed);
    };
    const handleMenuSelect = (info: SelectInfo) => {
        handleJumpTo(info.key);
      }

    const onOpenChange: MenuProps['onOpenChange'] = (keys) => {
        setOpenKeys(keys as string[]);
    };

    return (
        <div className={`${styles.navMenu} ${collapsed ? styles.navMenuCollapsed : ''}`}>
            <Menu
                inlineCollapsed={collapsed}
                selectedKeys={[pathname]}
                openKeys={openKeys}
                mode="inline"
                items={permsNavMenu} 
                onSelect={handleMenuSelect} 
                onOpenChange={onOpenChange}
                className={styles.menu}
                />
            <div className={styles.divider}></div>
            <div className={styles.collapseButton}>
                <Button
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={handleCollapse}
                    className={styles.collapseBtn}
                />
            </div>
        </div>
    );
}
  
export default PermsNavMenu;
